export default {
  en: {
    'pages.change-password.pass.match': 'New passwords do not match. Try again',
    'pages.change-password.change-password': 'Change password',
  },
};
